import { ReactElement } from 'react';
import { Box, Typography } from '@mui/material';
import { Address } from 'viem';

import { IpfsImage } from 'modules/common/components/IpfsImage';
import { cropString } from 'modules/common/utils/cropString';
import { globalTranslation, useTranslation } from 'modules/i18n';

import { useStyles } from './useStyles';

interface IPoolInfoProps {
  name?: string;
  imageIpfsLink?: string;
  address: Address;
  type?: 'delegate' | 'withdraw';
}

export function PoolInfoColumn({
  name,
  imageIpfsLink,
  address,
  type = 'delegate',
}: IPoolInfoProps): ReactElement {
  const { t, keys } = useTranslation(globalTranslation);
  const { classes } = useStyles();

  return (
    <Typography className={classes.root} variant="body1">
      <span>
        {type === 'delegate' ? t(keys.common.to) : t(keys.common.from)}
      </span>

      <IpfsImage className={classes.icon} ipfsLink={imageIpfsLink} />

      {name && (
        <Box color={theme => theme.palette.text.primary} component="span">
          {name}
        </Box>
      )}

      <span>{cropString(address)}</span>
    </Typography>
  );
}
